__turbopack_context__.v({
  "info-card": "InfoCard-module-scss-module__pS8w5G__info-card",
  "info-card__body": "InfoCard-module-scss-module__pS8w5G__info-card__body",
  "info-card__button": "InfoCard-module-scss-module__pS8w5G__info-card__button",
  "info-card__copy": "InfoCard-module-scss-module__pS8w5G__info-card__copy",
  "info-card__heading": "InfoCard-module-scss-module__pS8w5G__info-card__heading",
  "info-card__image": "InfoCard-module-scss-module__pS8w5G__info-card__image",
  "info-card__picture": "InfoCard-module-scss-module__pS8w5G__info-card__picture",
});
